import user from './user.js'

export default user;


// WEBPACK FOOTER //
// ./src/store/user/index.js